var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.296,
    d: "M7.778 8.056H7.13a1.296 1.296 0 0 0-1.296 1.296v5.185a1.296 1.296 0 0 0 1.296 1.296h6.481a1.296 1.296 0 0 0 1.297-1.296V9.352a1.296 1.296 0 0 0-1.297-1.296h-.648m-2.592 3.24v-7.13m0 0L8.426 6.112m1.944-1.944 1.945 1.944"
  })));
};
export default SvgIconShare;